import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure34 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#4573be', '#c55926'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ 
		     "Cambodge 2019",
		     "Éthiopie 2019",
		     "Burundi 2016",
		     "Malawi 2020",
		     "Rwanda 2019",
		     "Arménie 2015",
		     "Zambie 2018",
		     "Albanie 2017",
		     "Indonésie 2017",
		     "Myanmar 2015",
		     "Zimbabwe 2019",
		     "Tchad 2014",
		     "Haïti 2016",
		     "Afghanistan 2015",
		     "République-Unie de Tanzanie 2019",
		     "Ouganda 2019",
		     "Libéria 2020",
		     "Nigéria 2019",
		     "Ghana 2017",
		     "Cameroun 2018",
		     "Lesotho 2014",
		     "Inde 2015",
		     "Pakistan 2017",
		     "Guatemala 2018",
		     "Côte d’Ivoire 2019",
		     "Guinée-Bissau 2019",
		     "Népal 2016",
		     "Togo 2019",
		     "Sierra Leone 2018",
		     "Niger 2019",
		     "Burkina Faso 2019",
		     "Pérou 2019",
		     "Bénin 2019",
		     "Sénégal",
		     "Mali 2019",
		     "Papouasie-Nouvelle-Guinée 2018"
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 90,
        min: 0,
        tickInterval: 10,
        	format: '{value}',
        gridLineWidth: 2,
        title: {
          text: '%',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Hommes',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 81, 72, 65.9, 44.4, 55.8, 67.6, 57.8, 59.3, 57.4, 46.1, 45.9, 74.5, 53, 82.8, 45.7, 52, 48, 56.1, 41.4, 56.1, 16.1, 43.6, 37.7, 42.4, 63.8, 41.3, 30.4, 43.2, 22.7, 66.5, 50.8, 18, 49.5, 35.7, 44.8, 37.7 ],
      },
      {
        name: 'Femmes',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 82.8, 71.1, 63.7, 51.3, 51.2, 51.2, 48.3, 47.7, 47.1, 46.4, 44.9, 44.5, 44.3, 39.8, 38.8, 30.4, 25.6, 23.5, 23.4, 23.1, 21.9, 20.8, 19.3, 16.3, 11.2, 10.9, 10.8, 10.5, 9.5, 9.4, 8.5, 7.5,7.5, 6.5, 3.7, 2.4 ]
      }
    ]
}